<template>
  <v-navigation-drawer
    class="SideBar"
    dark
    permanent
    fixed
    app
    :mini-variant="!showDrawer"
  >
    <a class="SideBar__logo-container" @click.prevent="toggleDrawer">
      <img
        src="@/assets/images/sh_logo.png"
        alt="Shift health logo"
        class="SideBar__logo"
      />
      <span class="SideBar__title">Shift Health</span>
    </a>

    <v-list nav class="SideBar__nav-menu d-flex flex-column">
      <!-- Primary Chat Item -->
      <div
        v-for="(item, index) in primaryLinks"
        :key="index"
        class="SideBar__primary-item"
      >
        <LinkItem
          :path="item.link.path"
          :label="item.link.label"
          :icon="item.link.icon"
          :isPrimary="item.isPrimary"
        />
      </div>

      <div class="SideBar__regular-item">
        <!-- Regular Menu Items -->
        <div v-for="(item, index) in regularLinks" :key="index">
          <LinkItem
            :path="item.link.path"
            :label="item.link.label"
            :icon="item.link.icon"
          />
        </div>
      </div>

      <!-- More Menu with Popout -->
      <div v-if="moreLinks.length > 0" class="SideBar__more-menu">
        <v-menu
          v-model="moreMenuOpen"
          :close-on-content-click="true"
          offset-x
          :left="!showDrawer"
          :nudge-left="showDrawer ? 0 : 60"
          :nudge-right="showDrawer ? 0 : 0"
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <LinkItem
                :label="'More'"
                :icon="'mdi-dots-horizontal'"
                :isMore="true"
              />
            </div>
          </template>
          <v-card class="SideBar__popout-menu">
            <v-list dense>
              <LinkItem
                v-for="(itemLink, index) in moreLinks"
                :key="index"
                :label="itemLink.label"
                :icon="itemLink.icon"
                :path="itemLink.path"
                :isPopout="true"
                @click="moreMenuOpen = false"
              />
            </v-list>
          </v-card>
        </v-menu>
      </div>
    </v-list>

    <CustomerPicker :collapsed="!showDrawer" v-if="isShAdmin" />
  </v-navigation-drawer>
</template>

<script>
import CustomerPicker from '@/components/customer-picker/customer-picker.vue';
import LinkItem from '@/components/sidebar/link-item.vue';
import linkGroups from '@/components/sidebar/linkGroups.json';
import lodashGet from 'lodash/get';
import { createNamespacedHelpers } from 'vuex';

const { mapActions: sharedActions, mapGetters: sharedGetters } =
  createNamespacedHelpers('shared');
const { mapGetters: customerGetters, mapActions: customerActions } =
  createNamespacedHelpers('customer');

export default {
  name: 'SideBar',
  components: {
    CustomerPicker,
    LinkItem,
  },
  data() {
    return {
      visible: true,
      customersUsingPatientTab: [0, 1, 2, 4, 5],
      linkExpanded: [],
      openPanel: null,
      moreMenuOpen: false,
    };
  },
  computed: {
    ...sharedGetters({
      showDrawer: 'SHOW_DRAWER',
    }),
    ...customerGetters({
      customer: 'CUSTOMER',
      user: 'USER',
    }),
    isShAdmin() {
      return lodashGet(this.customer, 'customer_id') === 0;
    },
    primaryLinks() {
      const isPrivilegedUser = this.user && this.user?.is_privileged;
      return linkGroups.filter((linkGroup) => {
        if (linkGroup.isPrimary) {
          if (!linkGroup.isShAdmin && !linkGroup.isPrivileged) return true;
          if (linkGroup.isShAdmin && this.isShAdmin) return true;
          if (linkGroup.isPrivileged && isPrivilegedUser) return true;
        }
        return false;
      });
    },
    regularLinks() {
      const isPrivilegedUser = this.user && this.user?.is_privileged;
      return linkGroups.filter((linkGroup) => {
        if (!linkGroup.isPrimary && !linkGroup.isNested) {
          if (!linkGroup.isShAdmin && !linkGroup.isPrivileged) return true;
          if (linkGroup.isShAdmin && this.isShAdmin) return true;
          if (linkGroup.isPrivileged && isPrivilegedUser) return true;
        }
        return false;
      });
    },
    moreLinks() {
      const moreGroup = linkGroups.find((linkGroup) => linkGroup.isPopout);
      if (!moreGroup) return [];

      return moreGroup.links.filter((link) => {
        if (!link.isShAdmin) return true;
        return this.isShAdmin;
      });
    },
  },
  methods: {
    ...sharedActions(['toggleSidebar']),
    ...customerActions(['getFeatureFlags']),
    toggleDrawer() {
      this.toggleSidebar(!this.showDrawer);
    },
  },
};
</script>

<style lang="scss">
@import './sidebar';
</style>
